export const SUB2API_WEBCHAT_SESSION_REQUIRED = 'SUB2API_WEBCHAT_SESSION_REQUIRED';

type Sub2APIManagedConfigLike = {
	features?: {
		sub2api_sso_start_url?: string | null;
	};
} | null;

export const getSessionTokenForSub2APIManagedMode = ({
	managedMode,
	storedToken,
	allowStoredToken = false
}: {
	managedMode: boolean;
	storedToken?: string | null;
	cookie?: string | null;
	allowStoredToken?: boolean;
}) => {
	const token = storedToken ?? '';
	if (!managedMode || allowStoredToken) {
		return token;
	}

	return '';
};

export const shouldStartSub2APISSO = ({
	managedMode,
	error,
	hasSession
}: {
	managedMode: boolean;
	error?: string | null;
	hasSession?: boolean | null;
}) => managedMode && !error && hasSession === false;

export const shouldRootStartSub2APISSO = ({
	managedMode,
	pathname,
	devAuthEnabled = false
}: {
	managedMode: boolean;
	pathname?: string | null;
	devAuthEnabled?: boolean;
}) => {
	if (!managedMode) {
		return false;
	}

	const normalizedPathname = (pathname || '/').split('?')[0].replace(/\/+$/, '') || '/';
	if (devAuthEnabled) {
		return false;
	}

	return normalizedPathname !== '/auth';
};

export const shouldRootStartSub2APIDevAuth = ({
	managedMode,
	pathname,
	devAuthEnabled = false
}: {
	managedMode: boolean;
	pathname?: string | null;
	devAuthEnabled?: boolean;
}) => {
	if (!managedMode || !devAuthEnabled) {
		return false;
	}

	const normalizedPathname = (pathname || '/').split('?')[0].replace(/\/+$/, '') || '/';
	return normalizedPathname !== '/auth';
};

export const shouldRootRenderSub2APIDevAuth = ({
	managedMode,
	pathname,
	devAuthEnabled = false,
	storedToken
}: {
	managedMode: boolean;
	pathname?: string | null;
	devAuthEnabled?: boolean;
	storedToken?: string | null;
}) => {
	if (!managedMode || !devAuthEnabled || storedToken) {
		return false;
	}

	const normalizedPathname = (pathname || '/').split('?')[0].replace(/\/+$/, '') || '/';
	return normalizedPathname === '/auth';
};

export const getSub2APIErrorCode = (error: unknown): string => {
	if (typeof error === 'string') {
		return error;
	}

	if (!error || typeof error !== 'object') {
		return '';
	}

	const detail = 'detail' in error ? (error as { detail?: unknown }).detail : error;
	if (typeof detail === 'string') {
		return detail;
	}

	if (!detail || typeof detail !== 'object') {
		return '';
	}

	const code = (detail as { code?: unknown }).code;
	if (typeof code === 'string') {
		return code;
	}

	const nestedDetail = (detail as { detail?: unknown }).detail;
	if (typeof nestedDetail === 'string') {
		return nestedDetail;
	}
	if (nestedDetail && typeof nestedDetail === 'object') {
		const nestedCode = (nestedDetail as { code?: unknown }).code;
		if (typeof nestedCode === 'string') {
			return nestedCode;
		}
	}

	return '';
};

export const isSub2APIWebChatSessionRequiredError = (error: unknown) =>
	getSub2APIErrorCode(error) === SUB2API_WEBCHAT_SESSION_REQUIRED;

export const resolveSub2APISSOStartURL = ({
	config,
	fallbackBase = ''
}: {
	config?: Sub2APIManagedConfigLike;
	fallbackBase?: string;
}) => config?.features?.sub2api_sso_start_url || `${fallbackBase}/sub2api/sso/start`;
